// Legal counsel's review of a DPA or contract a vendor filed (release 3.1,
// persona spec 8.5 package T3). The vocabulary (the clauses, the verdicts, the
// outcomes) is the API's (packages/core/domain/legal_review.go) and is read
// from it with the reviews, so the console holds no copy of it.

import { request } from './api'

export type LegalClause = { code: string; name: string; why: string }
export type ClauseVerdict = { code: string; verdict: 'ADEQUATE' | 'INADEQUATE' | 'MISSING'; note?: string }
export type LegalOutcome = 'ACCEPTABLE' | 'CHANGES_REQUIRED' | 'NOT_ACCEPTABLE'

export type LegalReview = {
  id: string
  documentId: string
  vendorId: string
  outcome: LegalOutcome
  clauses: ClauseVerdict[]
  note: string
  reviewedBy: string
  reviewedAt: string
  current: boolean
}

export type LegalReviews = {
  documentId: string
  docType: string
  reviewable: boolean
  reviews: LegalReview[]
  clauses: LegalClause[]
  outcomes: LegalOutcome[]
  mayReview: boolean
}

export const OUTCOME_WORD: Record<string, string> = {
  ACCEPTABLE: 'Acceptable',
  CHANGES_REQUIRED: 'Changes required',
  NOT_ACCEPTABLE: 'Not acceptable',
}

export const VERDICT_WORD: Record<string, string> = {
  ADEQUATE: 'Adequate',
  INADEQUATE: 'Inadequate',
  MISSING: 'Missing',
}

// The agreements a legal review is for; certificates and audit reports are
// evidence, read by the people who review evidence.
export const LEGAL_REVIEW_KINDS = ['DPA', 'MSA', 'SOW', 'NDA']

export const legalApi = {
  reviews: (documentId: string) =>
    request<LegalReviews>('/v1/documents/' + encodeURIComponent(documentId) + '/legal-reviews'),
  record: (documentId: string, body: { outcome: LegalOutcome; clauses: ClauseVerdict[]; note: string }) =>
    request<{ review: LegalReview }>('/v1/documents/' + encodeURIComponent(documentId) + '/legal-reviews', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  // The documents register narrowed to the agreements nobody has recorded a
  // legal review of: legal counsel's queue, where its home tile lands.
  awaitingQuery: 'legalReview=awaiting',
}
